export default "__VITE_ASSET__CmqHrRTO__"